import AoneService from "../axiosbase";

//get hubs
export const getHubs = async (params) => {
  try {
    return await AoneService.get("assets/api/v1/hubs" + params);
  } catch (error) {
    return error;
  }
};

export const getHub = async (params) => {
  try {
    return await AoneService.get("assets/api/v1/hubs" + params);
  } catch (error) {
    return error;
  }
};

//filter hubs
export const filterHubs = async (params) => {
  try {
    return await AoneService.get("assets/api/v1/hubs/filter" + params);
  } catch (error) {
    return error;
  }
};

//gethubs by id
export const getHubsbyId = async (params) => {
  try {
    return await AoneService.get("assets/api/v1/hubs/" + params);
  } catch (error) {
    return error;
  }
};

//post hubs
export const postHubs = async (data) => {
  try {
    return await AoneService.post("assets/api/v1/hubs", data);
  } catch (error) {
    return error;
  }
};

//edit hubs
export const editHubs = async (data) => {
  try {
    return await AoneService.put("assets/api/v1/hubs", data);
  } catch (error) {
    return error;
  }
};

//patch hubs
export const editHubsbypatch = async (params, data) => {
  try {
    return await AoneService.patch(`assets/api/v1/hubs/${params}`, data);
  } catch (error) {
    return error;
  }
};

//retreive hub type
export const getHubTypes = async () => {
  try {
    return await AoneService.get("assets/api/v1/lookups/HubType");
  } catch (error) {
    return error;
  }
};

//delete hubs
export const deleteHubs = async (params) => {
  try {
    return await AoneService.delete("assets/api/v1/hubs/" + params);
  } catch (error) {
    return error;
  }
};

//export hubs
export const exportHubs = async (params) => {
  try {
    return await AoneService.get("assets/api/v1/hubs/download" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//hub template
export const getHubTemplate = async () => {
  try {
    return await AoneService.get("assets/api/v1/hubs/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//hub import
export const importHub = async (data) => {
  try {
    return await AoneService.post(`assets/api/v1/hubs/upload`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//get serviceareas
export const getServiceAreas = async (params) => {
  try {
    return await AoneService.get("assets/api/v1/areas" + params);
  } catch (error) {
    return error;
  }
};

//get service zones by hubs
export const getAllAreasbyHub = async (params) => {
  try {
    return await AoneService.get(`assets/api/v1/areas/hub/${params}`);
  } catch (error) {
    return error;
  }
};

//post serviceareas
export const postServiceAreas = async (data) => {
  try {
    return await AoneService.post("assets/api/v1/areas", data);
  } catch (error) {
    return error;
  }
};

//edit serviceareas
export const editServiceAreas = async (data) => {
  try {
    return await AoneService.put("assets/api/v1/areas", data);
  } catch (error) {
    return error;
  }
};

//delete serviceareas
export const deleteServiceareas = async (params) => {
  try {
    return await AoneService.delete("assets/api/v1/areas/" + params);
  } catch (error) {
    return error;
  }
};

//allowedevent in service areas
export const allowedeventLookup = async () => {
  try {
    return await AoneService.get("assets/api/v1/lookups/AllowedEvent");
  } catch (error) {
    return error;
  }
};

//template
export const getServiceAreasTemplate = async () => {
  try {
    return await AoneService.get("assets/api/v1/areas/template/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//export
export const exportServiceAreas = async (params) => {
  try {
    return await AoneService.get("assets/api/v1/areas/download" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//import
export const importServiceAreas = async (params, data) => {
  try {
    return await AoneService.post(
      `assets/api/v1/areas/${params}/upload`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};
